import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemTypeModel from '../../../models/ItemTypeModel';
import DataService from "../../../services/data.service";
import AddItemTypeBomTemplatePopup from '../Popups/ItemType_popup_AddBomTemplate';

interface Props {
    itemType: ItemTypeModel
}

const ItemType_tab_BomTemplates: React.FC<Props> = ({ itemType }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemType.id]);

    function getTableData() {
        DataService.get<any[]>('api/v1/BillOfMaterialTemplates/ByItemType/' + itemType.id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/BillOfMaterialTemplates/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc' },
        { title: 'Item type', dataProp: 'itemType.name' },
        { title: 'Category', dataProp: 'productCategory.name' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, itemType.id)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemTypeBomTemplates'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='BOM template'
                navigateUrl='/plm/itemsetup/billofmaterialtemplate/'
            />
            {showPopup && <AddItemTypeBomTemplatePopup itemType={itemType} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemType_tab_BomTemplates;